import {
  Box, Heading, IconButton, LinkBox,
  LinkOverlay, Modal, ModalBody, ModalCloseButton, ModalContent,
  ModalHeader, ModalOverlay, Tooltip, useDisclosure,
} from '@chakra-ui/react';
import { selectedDatabaseIdState, useIsUserInRole } from '@transport-insights/uikit';
import {
  FiList,
} from 'react-icons/fi';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useAllowedReportsList } from '../hooks/useReportsList';

export default function ReportListModal() {
  const hasDeveloperRole = useIsUserInRole('Developer');
  const { isOpen: isReportListOpen, onOpen: onOpenReportList, onClose: onCloseReportList } = useDisclosure();
  const rcaId = useRecoilValue(selectedDatabaseIdState);
  const reportsList = useAllowedReportsList(rcaId);
  const { pathname } = useLocation();
  const currentReportUrl = pathname.split('/').pop();

  // Filter reports list to only enabled reports and reports with a url
  // Check if devModeReport is true and verify hasDeveloperRole, otherwise show the report
  const enabledReportsList = Object.values(reportsList).filter((x) => x.enabled
      && x.url
      && (x.devModeReport ? hasDeveloperRole : true));

  return (
    <>
      <Tooltip label="Reports List">
        <IconButton
          onClick={onOpenReportList}
          icon={<FiList />}
          borderRadius="full"
          colorScheme="blue"
          variant="outline"
          ml={3}
        />
      </Tooltip>
      <Modal isOpen={isReportListOpen} onClose={onCloseReportList} size="xl">
        <ModalOverlay
          bg="blackAlpha.700"
          backdropFilter="blur(4px)"
        />
        <ModalContent>
          <ModalHeader>Performance Reports</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {enabledReportsList.map((report) => (
              <Box key={report.url}>
                <LinkBox
                  as="article"
                  p={2}
                  borderRadius="md"
                  border="2px solid"
                  borderColor={report.url === currentReportUrl ? 'brand.orange.500' : 'gray.50'}
                  backgroundColor={report.url === currentReportUrl ? 'brand.orange.500' : 'white'}
                  mb={2}
                  transition="all 200ms"
                  _hover={{ borderColor: 'brand.orange.500' }}
                >
                  <Heading size="sm">
                    <LinkOverlay
                      as={RouterLink}
                      to={`/performance/dashboard/${report.url}`}
                      onClick={onCloseReportList}
                      color={report.url === currentReportUrl ? 'white' : 'gray.800'}
                      fontWeight="normal"
                      textDecoration="none"
                    >
                      {report.name}
                    </LinkOverlay>
                  </Heading>
                </LinkBox>
                {(report.url === currentReportUrl && report.subReports) && report.subReports.map((subReport) => subReport.enabled
                    && (
                    <LinkBox
                      as="article"
                      p={2}
                      borderRadius="md"
                      border="2px solid"
                      borderColor={subReport.url === currentReportUrl ? 'brand.orange.500' : 'gray.50'}
                      backgroundColor={subReport.url === currentReportUrl ? 'brand.orange.500' : 'white'}
                      mb={4}
                      ml={4}
                      transition="all 200ms"
                      _hover={{ borderColor: 'brand.orange.500' }}
                      key={subReport.url}
                    >
                      <Heading size="xs">
                        <LinkOverlay
                          as={RouterLink}
                          to={`/performance/dashboard/${subReport.url}`}
                          onClick={onCloseReportList}
                          color={subReport.url === currentReportUrl ? 'white' : 'gray.800'}
                          fontWeight="normal"
                          textDecoration="none"
                        >
                          {subReport.name}
                        </LinkOverlay>
                      </Heading>
                    </LinkBox>
                    ))}
              </Box>
            ))}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
